<template>
  <div class="view-product-funnel">
    <h5 class="text-semibold mb-5">Funis de vendas</h5>
    <snow-data-table-header
      addText="Novo funil"
      class="mb-6"
      @add="modal = true"
      @searching="onSearch"
      :date-picker="false"
      :filters="false"
    />

    <div v-if="loading" class="text-center mt-8 pt-8">
      <b-spinner variant="primary" />
    </div>

    <template v-else-if="funnels.length">
      <div class="row">
        <div
          v-for="(funnel, i) in funnels"
          :key="i"
          class="mb-5 col-12 col-sm-6 col-md-4 col-xl-3"
        >
          <funnel-card
            :funnel="funnel"
            @edit="editFunnel"
            @remove="removeFunnel"
            @changeStatus="changeStatus"
          />
        </div>
      </div>
    </template>

    <div v-else class="d-flex flex-column align-items-center mt-7">
      <img class="d-block mb-5 mx-auto" src="@/assets/images/no-content.svg" />
      <h5>Ainda não há nada aqui</h5>
      <h5 class="text-dark-40 mb-5">
        Não há funis de vendas cadastrados até o momento.
      </h5>
      <snow-button text="Novo funil" icon="ph ph-plus" @click="modal = true" />
    </div>

    <responsive-modal
      v-model="modal"
      :title="funnelToEdit ? funnelToEdit.name : 'Novo funil'"
    >
      <funnel-form
        :funnel="funnelToEdit"
        @update="dispatch"
        @close="modal = false"
      />
    </responsive-modal>
  </div>
</template>

<script>
import FunnelCard from "@/components/product/funnel/FunnelCard.vue";
import FunnelForm from "@/components/product/funnel/FunnelForm";

export default {
  components: { FunnelForm, FunnelCard },
  data() {
    return {
      search: "",
      funnels: [],
      modal: false,
      loading: false,
      funnelToEdit: null
    };
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    removeFunnel(id) {
      let index = this.funnels.findIndex(funnel => funnel.id == id);

      this.$store
        .dispatch("funnel/delete", id)
        .then(() => {
          this.funnels.splice(index, 1);
        })
        .catch(() => {
          this.$message.error("Erro ao excluir funil");
        });
    },
    editFunnel(funnel) {
      this.funnelToEdit = funnel;
      this.modal = true;
    },
    dispatch() {
      this.loading = true;

      this.$store
        .dispatch("funnel/get", {
          product_id: this.$route.params.id,
          limit: 50
        })
        .then(({ data: { results } }) => {
          this.funnels = results.filter(f => f.name.includes(this.search));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStatus(funnel) {
      const params = {
        id: funnel.id,
        is_active: !funnel.is_active
      };

      const index = this.funnels.findIndex(f => f.id == params.id);
      if (index === -1) return;

      // substitui o objeto inteiro
      const updated = { ...this.funnels[index], is_active: params.is_active };
      this.$set(this.funnels, index, updated);

      this.$store.dispatch("funnel/put", params);
    },
    onSearch(text) {
      this.search = text;
      this.dispatch();
    }
  },
  watch: {
    modal(v) {
      if (!v) this.funnelToEdit = null;
    }
  }
};
</script>
